// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, object, oneOfType, string } from 'prop-types'
import ErrorSimple from './ErrorSimple'

class SelectDynamic extends React.Component {
  static propTypes = {
    emptyOptionLabel: string,
    disabled: bool,
    hideRXOnly: bool,
    id: string.isRequired,
    input: object.isRequired,
    label: string,
    meta: object.isRequired,
    onBlurCustom: func,
    onChangeCustom: func,
    options: oneOfType([
      array.isRequired,
      object.isRequired,
    ]),
    valueKey: string,
  }

  componentWillMount () {
    const { emptyOptionLabel } = this.props

    // creates an empty, non-value option if you give a label for one
    // NOTE - since this is defined here and not as a method on the class,
    // a component does not have the ability to add or remove an empty option label
    // but it can still dynamically update its list of options.
    this.emptyOption = (
      emptyOptionLabel
        ? <option value={''}>{emptyOptionLabel}</option>
        : null
    )
  }

  // assemble the list of options from native JS objects
  arrayOptions = () => {
    const {
      options,
      valueKey = 'value',
    } = this.props

    return options.reduce((a, d) => {
      a.push(d)
      return a
    }, []).map(d => (
      <option
        key={`${valueKey}-${d[valueKey]}`}
        title={d.label}
        value={d[valueKey]}>
        {d.label}
      </option>
    ))
  }

  // assemble the list of options from immutable.js Maps
  immutableOptions = () => {
    const {
      hideRXOnly,
      options,
      valueKey = 'value',
    } = this.props

    let {
      label = 'label',
    } = this.props

    if (valueKey === 'bandId') {
      label = 'bandDescription'
    } else if (valueKey === 'domainId') {
      label = 'domainDescription'
    } else if (valueKey === 'afsProtectionTypeId') {
      label = 'afsProtectionType'
    }

    return options.reduce((a, d) => {
      if (hideRXOnly && d.get(valueKey) === 'Rx only') {
        return a
      }
      a.push(d)
      return a
    }, []).map(d => (
      <option
        key={`${valueKey}-${d.get(valueKey)}`}
        title={d.get(label)}
        value={d.get(valueKey)}>
        {d.get(label)}
      </option>
    ))
  }

  // allows for a custom onBlur handler to be passed
  // defaults to redux-form's native input.onBlur otherwise.
  onBlur = e => {
    const {
      input,
      onBlurCustom,
    } = this.props

    return (
      onBlurCustom
        ? onBlurCustom(e, input.onBlur)
        : input.onBlur(e)
    )
  }

  // allows for a custom onChange handler to be passed
  // defaults to redux-form's native input.onChange otherwise.
  onChange = e => {
    const {
      input,
      onChangeCustom,
    } = this.props

    return (
      onChangeCustom
        ? onChangeCustom(e, input.onChange)
        : input.onChange(e)
    )
  }

  // dynamically build the options for this
  options = () => (
    Array.isArray(this.props.options)
      ? this.arrayOptions()
      : this.immutableOptions()
  )

  render () {
    const {
      disabled,
      id,
      input,
      meta,
    } = this.props

    // if the element is disabled, and it has no assigned value, it would
    // show its null label, eg. "-Select Option-"
    // since this is confusing as readonly text,
    // just give the thing opacity so it doesn't show.
    const selectClass = (
      disabled && !input.value
        ? 'opacity-0'
        : ''
    )

    return (
      <div className={'select-dynamic'}>
        <select
          id={id}
          {...input}
          className={selectClass}
          disabled={disabled}
          onBlur={this.onBlur}
          onChange={this.onChange}>
          {this.emptyOption}
          {this.options()}
        </select>
        <ErrorSimple
          error={meta.error}
          idRoot={id} />
      </div>
    )
  }
}

export default SelectDynamic
